import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Pyrates",
  "description": "",
  "published": "2006-08-22T00:00:00.000Z",
  "redirect_from": ["/blog/pyrates/swizec/386"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The internet's watchful eye has taken its eye off Pyrates 2 but c'est la vie, I only got to see it on Saturday and have only gotten around to saying something about it today.`}</p>
    <p>{`It's hard to decide what to say about this movie, on one side there is the me that is a movie lover and judges movies by how listenable they are. That is to say, can you put the movie in the background and just hearken to it. The first Pirates certainly is such a movie, lots of dialogue and lovely music, awesome, the second, sadly, is far from this. It is a completely new breed of movie, rather then telling a great story with lots of dialogue it is action and special effects packed. It was fun to watch, but in the same way as Rambo was fun to watch... but just not that very great.`}</p>
    <p>{`As far as the special effects go... hat's off. Very great work, have read a few articles on how they were done and I was simply amazed by how great it turned out to be.`}</p>
    <p>{`Now we come already to the part of this news post that has to do with the progress of September's page, and I'm still very sorry about the summer being updateless.`}</p>
    <p>{`The new page has been storyboarded (my first) and is well planned out, I just have some concept designs to make and re-learn a certain aspect of drawing which I seem to have misplaced along the way and I am feeling confident that the page will be finished on time... just when exactly on time is, I am not telling lest I jinx it.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      